export default {
    TeamManagement:{
        source: [],
        channel: []
    }
};